import _slicedToArray from "/home/denis/workspace/smartheat/pump-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from "react";
import { EnumInputModal } from "./EnumInputModal";
export function EnumInput(_ref) {
  var children = _ref.children,
      value = _ref.value,
      title = _ref.title,
      valuesEnum = _ref.valuesEnum,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      onChange = _ref.onChange;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpened = _useState2[0],
      setIsOpened = _useState2[1];

  var handleClose = function handleClose() {
    setIsOpened(false);
  };

  var handleDone = function handleDone(newValue) {
    onChange(newValue);
    setIsOpened(false);
  };

  var handleClick = function handleClick() {
    if (typeof value === "undefined" || disabled) {
      return;
    }

    setIsOpened(true);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(EnumInputModal, {
    key: isOpened ? "opened" : String(value),
    isOpen: isOpened,
    currentValue: value,
    title: title,
    valuesEnum: valuesEnum,
    onClose: handleClose,
    onDone: handleDone
  }), children({
    onClick: handleClick
  }));
}